import React, { FC, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { PublicLayout } from "@/components/layouts";
import { sanitizeHtml } from "@/core/security";
import { getFilesApi } from "@/shared/apis/apiRoot";

import { StyledPolicyPage } from "../styled";
import { PolicyFileType } from "./utils";

const PolicyPage: FC<{ type: PolicyFileType }> = ({ type }) => {
    const [template, setTemplate] = useState("");
    const { i18n } = useTranslation();

    useEffect(() => {
        const getTemplateByLanguage = async () => {
            await getFilesApi()
                .get<string>(`/files/${type}-${i18n.language}.html`)
                .then((response) => setTemplate(response.data));
        };
        getTemplateByLanguage();
    }, [i18n.language]);

    return (
        <PublicLayout>
            <StyledPolicyPage dangerouslySetInnerHTML={{ __html: sanitizeHtml(template) }} />
        </PublicLayout>
    );
};

export default PolicyPage;
